module.exports = __webpack_public_path__ + "static/redux-logo.80a9c063.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/redux-logo.png
// module id = 2547
// module chunks = 35783957827783